/* eslint-disable jira/filename-case */

import type { PreloadedQuery } from 'react-relay';
import type { RouteResource } from '@atlassian/react-resource-router';
import SidebarQuery, {
	type JsmProjectMenuWrapper_SidebarQuery,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-jsm-project-menu/src/ui/project-menu/__generated__/JsmProjectMenuWrapper_SidebarQuery.graphql';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { withGiraAggAnonSsrFix } from '../../../common/withGiraAggAnonSsrFix.tsx';

export const getQuery: Parameters<
	typeof createRelayResource<JsmProjectMenuWrapper_SidebarQuery>
	// oxlint-disable-next-line no-explicit-any
>[0]['getQuery'] = ({ match, query }: { match: any; query: any }, resourceContext: any) => {
	const cloudId = resourceContext?.tenantContext?.cloudId ?? '';
	let { projectKey } = getProjectKeyId(match, query);
	projectKey = projectKey ?? '';

	return {
		options: {
			fetchPolicy: 'store-and-network' as const,
		},
		parameters: SidebarQuery,
		variables: {
			cloudId,
			projectKey,
		},
	};
};

export const jsmProjectMenuContentSidebarResource: RouteResource<
	PreloadedQuery<JsmProjectMenuWrapper_SidebarQuery, Record<string, unknown>>
> = withGiraAggAnonSsrFix(
	createRelayResource<JsmProjectMenuWrapper_SidebarQuery>({
		type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
		getQuery,
	}),
);
